import { useMutation, useQueryClient } from "react-query";
import { patchDiagnosticStatus } from "apps/project-iq/api";
import {
  DiagnosticStatus,
  IDiagnostic,
} from "apps/project-iq/models/IDiagnostic";

interface IPatchStatusParams {
  status: DiagnosticStatus | null;
}

export const usePatchDiagnosticStatus = (diagnosticId: string) => {
  const queryClient = useQueryClient();
  return useMutation<IDiagnostic, Error, IPatchStatusParams>(
    ({ status }: IPatchStatusParams) =>
      patchDiagnosticStatus({ diagnosticId, status }),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["workspace-diagnostic", diagnosticId]);
      },
    },
  );
};
